import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import InvestorPage from "./pages/InvestorPage";
import FounderPage from "./pages/FounderPage";
import WhitePapers from "./pages/WhitePapers";
import "./index.css";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 text-gray-900">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/investor" element={<InvestorPage />} />
          <Route path="/founder" element={<FounderPage />} />
          <Route path="/whitepapers" element={<WhitePapers />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
